import { __assign } from "tslib";
import { FluentStyles } from '@uifabric/fluent-theme/lib/fluent/FluentStyles';
import { addVariants } from '@uifabric/variants';
import { CoherenceStyles } from './coherence';
import { CoherenceTheme } from './coherence/CoherenceTheme';
export var CoherenceCustomizations = {
    settings: { theme: __assign({}, CoherenceTheme) },
    scopedSettings: __assign(__assign({}, FluentStyles), CoherenceStyles)
};
addVariants(CoherenceCustomizations.settings.theme);
//# sourceMappingURL=CoherenceCustomizations.js.map